import { render, staticRenderFns } from "./QrFab.vue?vue&type=template&id=857a5966&scoped=true"
import script from "./QrFab.vue?vue&type=script&lang=js"
export * from "./QrFab.vue?vue&type=script&lang=js"
import style0 from "./QrFab.vue?vue&type=style&index=0&id=857a5966&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "857a5966",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
